import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { PosTableModule } from '../pos-table/pos-table.module';
import { AddPaymentModalComponent } from './add-payment-modal/add-payment-modal.component';
import { PosPaymentMethodComponent } from './pos-payment-method.component';



@NgModule({
  declarations: [
    PosPaymentMethodComponent,
    AddPaymentModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PosTableModule,
    NgxMaskModule
  ],
  exports: [PosPaymentMethodComponent]
})
export class PosPaymentMethodModule { }
